'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseClass2 = require('./BaseClass');

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Address = function (_BaseClass) {
  _inherits(Address, _BaseClass);

  /**
   * KundenId
   * @type {string}
   */

  /**
   * Anrede
   * @type {string}
   */

  /**
   * Nachname
   * @type {string}
   */

  /**
   * Vorname
   * @type {string}
   */

  /**
   * Ort
   * @type {string}
   */

  /**
   * Straße
   * @type {string}
   */

  /**
   * Hausnummer
   * @type {string}
   */

  /**
   * Hausnummerzusatz
   * @type {string}
   */

  /**
   * Email
   * @type {string}
   */

  /**
   * PLZ
   * @type {string}
   */

  /**
   * Geschlecht
   * @type {string}
   */

  /**
   * Typ der Adresse
   * @type {object}
   */

  /**
   * Beschreibung des Addresstyps
   * @type {string}
   */

  /**
   * Id des Addresstyps
   * @type {integer}
   */

  /**
   * Geburtsdatum
   * @type {Date}
   */

  /**
   * Adresse gültig von
   * @type {Date}
   */

  /**
   * Adresse gültig bis
   * @type {Date}
   */
  function Address() {
    _classCallCheck(this, Address);

    var _this = _possibleConstructorReturn(this, (Address.__proto__ || Object.getPrototypeOf(Address)).call(this));

    _this.Id = '';
    _this.Salutation = '';
    _this.Name1 = '';
    _this.Name2 = '';
    _this.City = '';
    _this.Street = '';
    _this.HouseNumber = '';
    _this.HouseNumberAddition = '';
    _this.Email = '';
    _this.Zip = '';
    _this.Gender = '';
    _this.AddressType = {
      Name: '',
      Id: 0
    };
    _this.DateOfBirth = '';
    _this.ValidFrom = '';
    _this.ValidUntil = '';
    _this.Phone = '';
    return _this;
  }
  /**
   * Telefonnummer
   * @type {string}
   */


  return Address;
}(_BaseClass3.default);

exports.default = Address;